import React from "react";
import { Button, ButtonProps } from "antd";
import styled from "styled-components";


const ButtonX = styled(Button)`
  text-transform: uppercase;
  height: 3.75rem;
  width: 15rem;
  border: none;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 1.25rem;
`;

export const Button3D = (props: ButtonProps) => {
  return (
    <ButtonX type={props.type} htmlType={props.htmlType} style={props.style} onClick={props.onClick} size={props.size}>
      {props.children}
    </ButtonX>
  );
};

export const BorderButton = styled(Button)`
  border: 0.833602px solid #03014C;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  font-weight: 400;
  width: 100%;
  height: 3rem;
  color:#03014C;
  margin-top: 1.5rem;
`;
export const ContainerBtn = styled(Button)`
  width: 100%;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.8rem;
`;
export interface MyProps {
  readonly big?: boolean;
  readonly long?: boolean;
  readonly green?: boolean;
}

export const PrimaryButton = styled.button<MyProps>`
  text-transform: uppercase;
  color: #fff;
  font-size: 20px;
  background: ${(props) => props.green ? "rgba(9, 185, 79, 1)" : "rgba(17, 150, 221, 1)"};
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  height: ${(props) => props.big ? "60px" : "48px"};
  width: ${(props) => props.long ? "240px" : "164px"};
  border: none; 
  outline: none;
`;
export const ButtonA = styled.button<MyProps>`
  text-transform: uppercase;
  font-size: 20px;
  color: #1196DD;
  background: #fff;
  height: ${(props) => props.big ? "60px" : "48px"};
  width: ${(props) => props.long ? "240px" : "164px"};
  border: 2px solid #1196DD;
  outline: none;
`

export const PrimaryButtonX = styled(Button)`
  text-transform: uppercase;
  color: #fff;
  font-size: 20px;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  height: 60px;
  width: 160px;
  border: none; 
  outline: none;
`

export const GreenButton = styled(Button)`
  text-transform: uppercase;
  color: #fff;
  background-color: rgba(9, 185, 79, 1);
  font-size: 20px;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  height: 60px;
  width: 240px;
  border: none; 
  outline: none;
`

export const HButton = styled(Button) <ButtonProps>`
  background: ${(props) => props.danger ? "rgba(9, 185, 79, 1)" : "yello"}
`